import React from "react";
import { useMediaQuery } from "react-responsive";
import { Outlet } from "react-router-dom";

const UniversalLayout = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  // Verificar se o sidebar está expandido
  const [isSidebarExpanded, setIsSidebarExpanded] = React.useState(false);

  // Escutar mudanças no localStorage ou state global do sidebar
  React.useEffect(() => {
    const handleSidebarChange = () => {
      const sidebarState = localStorage.getItem("sidebarExpanded");
      if (sidebarState !== null) {
        setIsSidebarExpanded(JSON.parse(sidebarState));
      }
    };

    // Verificar estado inicial
    handleSidebarChange();

    // Escutar mudanças
    window.addEventListener("storage", handleSidebarChange);
    window.addEventListener("sidebarToggle", handleSidebarChange);

    return () => {
      window.removeEventListener("storage", handleSidebarChange);
      window.removeEventListener("sidebarToggle", handleSidebarChange);
    };
  }, []);

  // Calcular margem do sidebar
  const getSidebarMargin = () => {
    if (isMobile) return "ml-0";
    return isSidebarExpanded ? "ml-72" : "ml-16";
  };

  // Calcular largura disponível considerando o sidebar
  const getAvailableWidth = () => {
    if (isMobile) return "100%";
    const sidebarWidth = isSidebarExpanded ? 288 : 64; // w-72 = 288px, w-16 = 64px
    return `calc(100% - ${sidebarWidth}px)`;
  };

  // Memoiza os filhos: ao abrir/fechar o sidebar, só a margem/largura deste
  // wrapper muda — NÃO precisamos re-renderizar o conteúdo da página (que pode
  // ser pesado, como tabelões). Sem isto, cada toggle re-renderizava a página
  // inteira, causando lentidão ("travamento") na animação.
  const renderedChildren = React.useMemo(() => {
    if (!children) return null;
    return React.Children.map(children, (child) =>
      React.isValidElement(child) && typeof child.type === "function"
        ? React.cloneElement(child, { isMobile })
        : child
    );
  }, [children, isMobile]);

  return (
    <div
      className={`transition-[margin,width] duration-200 ${getSidebarMargin()} overflow-x-hidden`}
      style={{
        minHeight: "calc(100vh - 64px)",
        width: getAvailableWidth(),
        maxWidth: "100%",
      }}
    >
      {/* Container principal com 95% da largura */}
      <div
        className={`mx-auto py-2 sm:py-4 overflow-x-hidden ${
          isMobile ? "px-2" : ""
        }`}
        style={{
          width: isMobile ? "calc(100% - 1rem)" : "95%",
          maxWidth: "100%",
          minHeight: "calc(100vh - 64px - 2rem)", // Subtraindo altura do header e padding
        }}
      >
        {/* Se tem children, renderiza children. Se não, renderiza Outlet para rotas aninhadas */}
        {children ? renderedChildren : <Outlet context={{ isMobile }} />}
      </div>
    </div>
  );
};

export default UniversalLayout;
